module.exports = __webpack_public_path__ + "img/step3.1a54f835.png";